export function jusIframe() {
    let url = window.location.origin;
    if (url == process.env.VUE_APP_IFRAME_HOST) {
        return true;
    }
    return false
}
